import React from 'react'
import { useParams } from 'react-router-dom'
import Container from 'react-bootstrap/Container'

import AppointmentPanel from '../components/presentations/appointment/AppointmentPanel'

/**
 * Where a texted or emailed {CONFIRM_LINK} lands (US-37724).
 *
 * Reached with no session at all — the guest token in `?token=` is picked up by
 * useStorageApp and is the only credential. That token is scoped to this one event and
 * expires, unlike every other portal link the platform issues.
 *
 * The page is deliberately just the panel. A client following "confirm your appointment" has
 * one decision to make, and burying it in a document view is how it gets missed.
 *
 * `enabled` is hard-coded true here, and that is deliberate (US-38458). Feature flags reach this
 * app only in the login response, and this page has no login — useStorageApp clears the stored
 * company and user and keeps only the guest token — so `featureFlags` is null on this path.
 * Reading `schedulingWeb` here would gate the confirm link on the ABSENCE of flags rather than
 * on the flag, breaking every texted link the moment scheduling is switched on. The gate that
 * protects this page is the core API's, on GET/PUT /v6/portal/appointments/*: with the flag off
 * it answers 404, the fetch yields nothing, and the panel renders null on its own.
 */
const AppointmentDetail = () => {
  const { id } = useParams()

  return (
    <Container className='mx-auto appointment-page'>
      <AppointmentPanel eventId={id} enabled />
    </Container>
  )
}

export default AppointmentDetail
